export function remove<T>(xs: Array<T>, x: T): void {
   const i = xs.indexOf(x);
   if (i >= 0) xs.splice(i, 1);
}

export function append<T>(xs: Array<T>, x: T): Array<T> {
   xs.push(x);
   return xs;
}

export function reduce<T, U>(xs: Array<T>, acc: U, f: (acc: U, x: T) => U): U {
   for (const x of xs) acc = f(acc, x);
   return acc;
}

export function filter<T>(xs: Array<T>, f: (x: T) => boolean): Array<T> {
   const results: T[] = [];
   return reduce(xs, results, (xs, x) => (f(x) ? append(xs, x) : xs));
}

export function map<T, U>(xs: T[], f: (x: T) => U): U[] {
   const results: U[] = [];
   return reduce(xs, results, (xs, x) => append(xs, f(x)));
}

export function groupBy<T, K extends string>(
   xs: Array<T>,
   f: (x: T) => K,
): Record<K, T[]> {
   const map = {} as Record<K, T[]>;
   for (const x of xs) {
      const key: K = f(x);
      const group: T[] = map[key] ?? ([] as T[]);
      group.push(x);
      map[key] = group;
   }
   return map;
}
